<template>
    <div class="page-wrapper">
        <Navbar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Confirm Email" />
            <ConfirmEmail />
        </div>
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layouts/Navbar'
import PageTitle from '../Common/PageTitle'
import ConfirmEmail from '../ConfirmEmail/ConfirmEmail'
import Footer from '../Layouts/Footer'

export default {
    name: 'ConfirmEmailPage',
    components: {
        Navbar,
        PageTitle,
        ConfirmEmail,
        Footer,
    }
}
</script>
